import React, { useState } from 'react';
import PropTypes from 'prop-types'
import { Button, Form,Container, Spinner } from 'react-bootstrap';
import MaskedFormControl from 'react-bootstrap-maskedinput'
import { useNavigate , useParams} from 'react-router-dom';
import './../CSS/form.css';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from 'moment'

import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification'
import {SCHOLARSHIP_REGISTER_STUDENT} from './../../url/index'
import NotifyError from './../../Components/assets/Modals/errorModal'

const Scholarship = () => {

  
    const navigate = useNavigate();
    const navigateToHome = () => {
     navigate('/');
    }

    const [validated, setValidated] = useState(false);
    const initialInputState = { 
      FirstName: "",
       MiddleName:"",
       LastName:"",
       PersonalEmail:"",
       PersonalCellNumber:'',
       ParentCellNumber:'',
       AdhaarNumber:'',
       year:2024,
       DOB: '',
       dobError:'',
       Gender:'',
       Stream:'',
       Category:'',
       Address:'',
       FatherName:'',
        MotherName:'',
        LastQualifyRollNumber:'',
        LastQualifyMarks:'',
        SchoolInfo:'',
        Income:null,
        IsSuccess:false,
        message:'',
        isLoading:false,
        isHideErrorModal:true,
        errMessage:'',
        validationError:null,
        errortitle:'',
        categoryError:'',
        title:'',
        incomeError:'',
        msgList:[]
     
     };
     const [eachEntry, setEachEntry] = useState(initialInputState);
     const {FirstName, LastName, MiddleName,
        PersonalEmail, PersonalCellNumber,ParentCellNumber,
        AdhaarNumber, DOB, dobError, Gender, Stream,Category, Address,
        FatherName, MotherName,
       LastQualifyRollNumber, LastQualifyMarks,
         SchoolInfo,IsSuccess, message, isLoading, isHideErrorModal, msgList,
         errMessage, validationError, errortitle, categoryError, Income,  year, title, incomeError} = eachEntry;

         const handleInputChange = e => {
            setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
        };
      
        const handleNumberChange = e => {
            let num = e.target.value.replace(/\D/g, "");
            setEachEntry({ ...eachEntry, [e.target.name]: num });
        };
       
      const handleKeyDown = (e) =>{
        if (e.key === " ") {
          e.preventDefault();
        }
      }

      const handleDateChange = (e) =>{
        setEachEntry({ ...eachEntry, [e.target.name]: e.target.value, dobError: "" });
        }
        
        const dateValidation = () => {
        
        const dateArray = DOB.split("/");
        
        const day = parseInt(dateArray[0]); 
        const month = parseInt(dateArray[1]); 
        const year = parseInt(dateArray[2]); 
        const currentYear = new Date().getFullYear() 
        
        
        
        if(day > 31)
        {
          setEachEntry({ ...eachEntry, dobError: "Enter a valid day" });
          return false
        }
        else if(month > 12)
        {
          setEachEntry({ ...eachEntry, dobError: "Enter a valid month" });
          return false
        }
        else if(currentYear < year || (currentYear - year) < 12)
        {
          setEachEntry({ ...eachEntry, dobError: "Enter a valid year" });
          return false
        }
        
        else{
          var mydate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]); 
        
          setEachEntry({ ...eachEntry, DOB: mydate, dobError: "" });
          return true;
        }
        
        }
        
        const handleRadioChange = (e) => {
         
          setEachEntry({ ...eachEntry, [e.target.name]: e.target.id });
        }

        const handleDDLChange = (e) =>{
            const {name,value,id} = e.target;
              setEachEntry({ ...eachEntry, [name]: value, [[id]]:'' });
          }

          const handleMarkChange = (e) => {
            let num = e.target.value
            if(num.includes("."))
            {
              const dateArray = num.split(".");
              if(dateArray.length > 0)
              {
                
                const temp2 = parseInt(dateArray[1]);
                if(temp2 < 100) 
                setEachEntry({ ...eachEntry, [e.target.name]: num });
              }
             
            }
            else{
              if(num < 100)
              setEachEntry({ ...eachEntry, [e.target.name]: num });
            }
           
           
          }

        const handleSubmit = async (event) => {
  
            const form = event.currentTarget;
            event.preventDefault();
            event.stopPropagation();
            if (form.checkValidity() === true && dateValidation() && handleSelectValidation()) {
             SaveStudent();
             }
             else{
               window.scrollTo(0, 0);
             }
             setValidated(true);
            //
            
          };

          const SaveStudent = async () => {
            let response = null;
          var dob = moment.utc(eachEntry.DOB, "DD-MM-YYYY");
          
            try {
             // let formData = { ...eachEntry,DOB:dob, PIN: parseInt(eachEntry.PIN), LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), Amount: parseInt(eachEntry.Amount)}
            let payload = {
              FirstName: eachEntry.FirstName,
              MiddleName:eachEntry.MiddleName,
              LastName:eachEntry.LastName,
              PersonalEmail:eachEntry.PersonalEmail,
              PersonalCellNumber:eachEntry.PersonalCellNumber,
              ParentCellNumber:eachEntry.ParentCellNumber,
              AdhaarNumber:eachEntry.AdhaarNumber,
              Income:parseInt(eachEntry.Income),
              DOB: dob,
              Gender:eachEntry.Gender,
              Stream:eachEntry.Stream,
              Category:eachEntry.Category,
              Year:  year,
              Address:eachEntry.Address,
              FatherName:eachEntry.FatherName,
               MotherName:eachEntry.MotherName,
               LastQualifyRollNumber:eachEntry.LastQualifyRollNumber,
               LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks),
               SchoolName:eachEntry.SchoolInfo,
            }
          //console.log("payload", payload)
           setEachEntry({ ...eachEntry, isLoading: true});
           response = await axios.post(SCHOLARSHIP_REGISTER_STUDENT, payload);
          
           if(response.status === 201)
           {
            let temp = []
            temp.push("You have successfully registered for CTG Scholarship")
             setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Success", msgList: temp});
            // handleClear()
          }
          
          else{
            setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Error occurred!", message:"Error Occurred...!"});
          
          }
          
            }
             catch (error) {
             
              if(error.response.data)
              {
                 if(error.response.status === 400)
               {
                  if(error.response.data.Error.ValidationErrors != null)
                  {
                    const validationError =  error.response.data.Error.ValidationErrors
                    setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: error.response.data.Error.Message, validationError: validationError});
                   // setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true,title:"Error occurred!", message: error.response.data.Error.Message});
                  }
                  else{
                    setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: error.response.data.Error.Message });
                  }
               
               }
               else{
                setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
               }
              }
              else
              setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
          }
          }


          const handleClose = () => {
            window.location.reload();
            window.scrollTo(0, 0);
          }
          const handleCloseErrorModal = () => {
            setEachEntry({ ...eachEntry, isHideErrorModal: true,  msgList: [], errMessage : '',errortitle:'', validationError: null});
          }

          const handleClear = () => {
            
            setEachEntry(initialInputState);
           
          }

          const handleSelectValidation = (e) => {
            const { Category, Income} = eachEntry
            
                  
              if(Category == null || Category.length == 0)
              {
                setEachEntry({ ...eachEntry, categoryError: "Select Category" });
                return  false
                }
                if(Income == null || Income.length == 0)
              {
                setEachEntry({ ...eachEntry, incomeError: "Select Income" });
                return  false
                }
             return true;
            
            }

  return (
    <div className='scholarship'>
    <div className='container'>
  
      <div className='heading2'>
               <label style={{color:'#800080'}}>CTG Scholarship Registration Form</label>
              
                </div>
                <label style={{color:'red', fontSize:'small'}}><i>This Form is applicable for students who have recently appeared in Metric Examination</i></label>
                
      <Form className='details' noValidate validated={validated} onSubmit={handleSubmit}>
       {/* <Container> 
      <Row className="mb-2"> */}
 <Form.Group  className="mb-2">
  <Form.Label style={{color:'#800080'}}><span className="required">10<sup>th</sup> Pass out year</span></Form.Label>
  <Form.Select size='sm' aria-label="Default select example" required
   name="year"
   defaultValue={2024}
   onChange = {handleDDLChange}
   style={{ width: '180px' }} 
  >
  
  <option value= {2024}>2024</option>
 
</Form.Select>
</Form.Group>


  <Form.Group   className="mb-2" controlId="validationCustom01">
    <Form.Label style={{color:'#800080'}}><span className="required">First Name</span></Form.Label>
    <Form.Control 
    size='sm' 
    type="input" 
    placeholder="Enter first name" 
    required = {true}
    onChange={handleInputChange}
    value={FirstName}
    name="FirstName"
    onKeyDown={handleKeyDown}
    />
    <Form.Control.Feedback type="invalid">
              Please enter  first name.
            </Form.Control.Feedback>
  </Form.Group>

 

  <Form.Group  className="mb-2" controlId="formBasicPassword">
    <Form.Label style={{color:'#800080'}}>Middle Name</Form.Label>
    <Form.Control
     size='sm'
      type="input"
       placeholder="Enter middle name"
       onChange={handleInputChange}
       value={MiddleName}
       name="MiddleName"
       onKeyDown={handleKeyDown}
       />
  </Form.Group>

  <Form.Group  className="mb-2" controlId="formBasicPassword">
    <Form.Label style={{color:'#800080'}}><span className="required">Last Name</span></Form.Label>
    <Form.Control 
    size='sm'
     type="input"
      placeholder="Enter last name"
       required
       onChange={handleInputChange}
       value={LastName}
       name="LastName"
       onKeyDown={handleKeyDown}
       />
    <Form.Control.Feedback type="invalid">
              Please enter  last name.
            </Form.Control.Feedback>
  </Form.Group>
 
  <Form.Group   className="mb-2">
    <Form.Label style={{color:'#800080'}}>Contact number</Form.Label>
    <Form.Control 
    size='sm' 
    type="tel"
    maxLength="10"
    minLength="10"
     pattern="[0-9]*"
      
      onChange={handleNumberChange}
      value={PersonalCellNumber}
      name="PersonalCellNumber"
      />
  </Form.Group>
  <Form.Group   className="mb-2" controlId="formBasicEmail">
    <Form.Label style={{color:'#800080'}}>Email</Form.Label>
    <Form.Control
     size='sm'
      type="email"
       placeholder="Enter email address"
       onChange={handleInputChange}
       value={PersonalEmail}
       name="PersonalEmail"
       />
    <Form.Control.Feedback type="invalid">
    Plesae enter valid email.
            </Form.Control.Feedback>
  </Form.Group>
  {/* </Row> */}

   {/* <Row className="mb-2"> */}
  <Form.Group  className="mb-2">
  
  <Form.Label style={{color:'#800080'}}><span className="required">Date Of Birth</span></Form.Label>
        <MaskedFormControl size='sm'
         type='text' 
          mask='11/11/1111'
          required
          onChange={handleDateChange}
          value = {DOB}
          name="DOB"
          />
        <Form.Control.Feedback type="invalid">
              Please enter  DOB.
            </Form.Control.Feedback>
            <Form.Text style={{color:"red"}}>
            {dobError}
       </Form.Text>
      </Form.Group>
  
  <Form.Group className="mb-2">
  <Form.Label style={{color:'#800080'}}><span className="required">Gender</span></Form.Label>
  {['radio'].map((type) => (
    <div key={`inline-${type}`} className="mb-2">
      <Form.Check
      size='sm'
        inline
        label="Male"
        name="Gender"
        type={type}
        value = {Gender}
        onChange = {handleRadioChange}
        id= 'Male'
        required
      />
      <Form.Check
      size='sm'
        inline
        label="Female"
        name="Gender"
        type={type}
        value = {Gender}
        onChange = {handleRadioChange}
        id= 'Female'
        required
      />
       <Form.Check
        size='sm'
        inline
        label="Other"
        type={type}
         name="Gender"
         value = {Gender}
         onChange = {handleRadioChange}
         id= 'Other'
         required
      /> 
      
    </div>
    
  ))}
   <Form.Control.Feedback type="invalid">
     Please select  gender.
   </Form.Control.Feedback>
  </Form.Group>

  <Form.Group  className="mb-2">
  
  <Form.Label style={{color:'#800080'}}>Apply Stream</Form.Label>
  <Form.Select size='sm' aria-label="Default select example" 
   name="Stream"
   defaultValue={'DEFAULT'}
   onChange = {handleDDLChange}
  >
  <option value="DEFAULT" disabled>Select</option>
   {/* <option value="" disabled selected>Select</option>  */}
  <option value= {"Arts"}>Arts</option>
  <option value={"Science"}>Science</option>
  <option value={"Commerce"}>Commerce</option>
</Form.Select>
</Form.Group>
  
<Form.Group  className="mb-2">
<Form.Label style={{color:'#800080'}}><span className="required">Select Category</span></Form.Label>
<Form.Select required size='sm' aria-label="Default select example"
 name="Category"
 id = 'categoryError'
 defaultValue={'DEFAULT'}
 onChange = {handleDDLChange}
>
<option value="DEFAULT" disabled>Select</option>
  <option value={"ST"}>ST</option>
  <option value={"SC"}>SC</option>
  <option value={"OBC"}>OBC</option>
  <option value={"SEBC"}>SEBC</option>
  <option value={"General"}>General</option>
</Form.Select>
<Form.Control.Feedback type="invalid">
     Please select  category.
   </Form.Control.Feedback>
   <Form.Text style={{color:"red"}}>
            {categoryError}
       </Form.Text>
</Form.Group>

<Form.Group   className="mb-2">
    <Form.Label style={{color:'#800080'}}>Adhaar Number</Form.Label>
    <Form.Control size='sm' 
    type="tel"
    maxLength="12"
    minLength="12"
     pattern="[0-9]*"
      onChange={handleNumberChange}
      value={AdhaarNumber}
      name="AdhaarNumber"
    />
  </Form.Group>


<Form.Group className="mb-2" controlId="formBasicPassword" required>
    <Form.Label style={{color:'#800080'}}><span className="required">Father's Name</span></Form.Label>
    <Form.Control size='sm'
     type="input" 
     placeholder="Enter father name"
      required
      value={FatherName}
      name = "FatherName"
      onChange={handleInputChange}
      />
    <Form.Control.Feedback type="invalid">
     Please enter  father's name.
   </Form.Control.Feedback>
  </Form.Group>

  <Form.Group  className="mb-2" controlId="formBasicPassword" required>
    <Form.Label style={{color:'#800080'}}><span className="required">Mother's Name</span></Form.Label>
    <Form.Control size='sm'
     type="input" 
     placeholder="Enter mother name" 
     
     value={MotherName}
     name = "MotherName"
     onChange={handleInputChange}
     required/>
    <Form.Control.Feedback type="invalid">
     Please mother's  name.
   </Form.Control.Feedback>
  </Form.Group>
  <Form.Group  className="mb-2" required>
    <Form.Label style={{color:'#800080'}}><span className="required">Parent's Contact Number</span></Form.Label>
    <Form.Control size='sm'
      type="tel"
      maxLength="10"
      minLength="10"
       pattern="[0-9]*"
        required
        onChange={handleNumberChange}
        value={ParentCellNumber}
        name="ParentCellNumber"
     />
    <Form.Control.Feedback type="invalid">
     Please enter Parent's Contct no.
   </Form.Control.Feedback>
  </Form.Group>

  <Form.Group  className="mb-2">
<Form.Label style={{color:'#800080'}}><span className="required">Parent Income</span></Form.Label>
<Form.Select required size='sm' aria-label="Default select example"
 name="Income"
 id = 'incomeError'
 defaultValue={'DEFAULT'}
 onChange = {handleDDLChange}
>
<option value="DEFAULT" disabled>Select</option>
  <option value={1}>0 to 1 Lakh</option>
  <option value={2}>1 to 2.5 Lakh</option>
  <option value={3}>2.5 to 3.6 Lakh</option>
  <option value={4}>More than 3.6 Lakh</option>
</Form.Select>
<Form.Control.Feedback type="invalid">
     Please select  Income.
   </Form.Control.Feedback>
   <Form.Text style={{color:"red"}}>
            {incomeError}
       </Form.Text>
</Form.Group>

 
  <Form.Group  className="mb-2" controlId="formControlsTextarea">
    <Form.Label style={{color:'#800080'}}><span className="required">{ "School Name"}</span></Form.Label>
     <Form.Control size='sm'
     type="input" 
     placeholder="Enter school name" 
     value={SchoolInfo}
     name = "SchoolInfo"
     onChange={handleInputChange}
     required/>
    <Form.Control.Feedback type="invalid">
     Please enter school name.
   </Form.Control.Feedback>
  </Form.Group>
 

  <Form.Group  className="mb-2" controlId="formBasicPassword" required>
    <Form.Label style={{color:'#800080'}}><span className="required">Roll number</span></Form.Label>
    <Form.Control size='sm'
     type="input" 
     placeholder="Enter roll number" 
     value={LastQualifyRollNumber}
     name = "LastQualifyRollNumber"
     onChange={handleInputChange}
     required/>
    <Form.Control.Feedback type="invalid">
     Please enter roll number.
   </Form.Control.Feedback>
  </Form.Group>

  <Form.Group  className="mb-2">
    <Form.Label style={{color:'#800080'}}>% of Marks in metriculation</Form.Label>
    <Form.Control size='sm' 
    type="number" 
     className="w-80" 
     max={100}
     maxLength = {5}
     value={LastQualifyMarks}
     name = "LastQualifyMarks"
     onChange={handleMarkChange}
     />
  </Form.Group>
  
  <Form.Group  xs={3} className="mb-2" controlId="formControlsTextarea">
    <Form.Label style={{color:'#800080'}}><span className="required">Address</span></Form.Label>
    <textarea size='sm' className="form-control rounded-0"
     required id="exampleFormControlTextarea2" 
     rows="3" cols = '40'
     placeholder="Enter full address with PIN Code"
     value={Address}
     name = "Address"
     onChange={handleInputChange}
     ></textarea>
    <Form.Control.Feedback type="invalid">
     Please enter  address.
   </Form.Control.Feedback>
  </Form.Group>
  {/* <Row className="mb-2"> */}
 
 
 
  <div className="form-row" style={{width:'30%'}}>
  <div className="d-grid gap-2">
    <p></p>
    
  <button className="btn btn-primary" style={{background:'#800080'}} type="submit">
  <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
    Register
    </button>
  
  <button className="btn btn-primary"style={{background:'#cc5500'}}  type="button" onClick={handleClear}>Clear</button>
</div>
  {/* <div class="col">
  <Form.Group  className='Reg' controlId="formControlsTextarea">
  <Button variant='success' class="btn btn-primary"  type="submit">
  <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
   Register
    
  </Button>
  </Form.Group>
  </div>

  <div class="col">
  <Form.Group className='Reg' controlId="formControlsTextarea">
  
  <Button   variant='danger' type="submit" onClick={navigateToHome}>
    Cancel
  </Button>
  </Form.Group>
  </div> */}
  
  </div>

  

 
  {/* </Container>  */}
</Form>

<Notification
IsSuccess = {IsSuccess}
handleClose = {handleClose}
msgList = {msgList}
title = {title}

/>

{!isHideErrorModal && <NotifyError
isHide = {isHideErrorModal}
 handleCloseErrorModal ={handleCloseErrorModal}
  title = {errortitle}
   message = {errMessage}
    Errors ={validationError}
/>} 
    </div>
    </div>
  )
}

export default Scholarship